import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  LOANS_AND_BONDS_DATE_COLUMN_INDEXES,
  LOANS_AND_BONDS_TABLE_COLUMN_WIDTHS,
  LOANS_AND_BONDS_TABLE_HEADERS,
  LOANS_AND_BONDS_TABLE_MIN_WIDTH,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/constants.ts';
import { LoanOrBondRow } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/LoanOrBondRow.tsx';
import { FinancialConditionTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTable.tsx';
import type { ILoansAndBondsGroupProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/types.ts';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import type { TFinancialConditionFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { createLoanOrBond } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const LoansAndBondsGroup: React.FC<ILoansAndBondsGroupProps> = ({
  name,
  title,
  disabled,
  lenderOptions,
  currencyOptions,
  isBanksLoading,
  isCurrenciesLoading,
}) => {
  const { control } = useFormContext<TFinancialConditionFormValues>();
  const { fields, append, remove } = useFieldArray({ control, name });

  return (
    <Box sx={financialConditionGenerationStyles.financialAssistanceGroup}>
      <Typography sx={{ fontWeight: 700 }}>{title}</Typography>

      <FinancialConditionTable
        ariaLabel={title}
        headers={[...LOANS_AND_BONDS_TABLE_HEADERS]}
        showActions={fields.length > 1}
        dateColumnIndexes={[...LOANS_AND_BONDS_DATE_COLUMN_INDEXES]}
        columnWidths={[...LOANS_AND_BONDS_TABLE_COLUMN_WIDTHS]}
        minWidth={LOANS_AND_BONDS_TABLE_MIN_WIDTH}
      >
        {fields.map((field, index) => (
          <LoanOrBondRow
            key={field.id}
            name={name}
            index={index}
            canRemove={fields.length > 1}
            disabled={disabled}
            lenderOptions={lenderOptions}
            currencyOptions={currencyOptions}
            isBanksLoading={isBanksLoading}
            isCurrenciesLoading={isCurrenciesLoading}
            onRemove={() => remove(index)}
          />
        ))}
      </FinancialConditionTable>

      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => append(createLoanOrBond())}
        disabled={disabled}
        sx={documentGenerationFormStyles.addButton}
      >
        Додати запис
      </Button>
    </Box>
  );
};
